import { render, staticRenderFns } from "./TurnoIndex.vue?vue&type=template&id=23ada8b9"
import script from "./TurnoIndex.vue?vue&type=script&lang=js"
export * from "./TurnoIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports